import ActiveLink from "components/ReuseableCompos/ActiveLink";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import styled from "styled-components";
const FaqSidebarContent = ({
  content,

  lastPath,
}) => {
  const { t } = useTranslation("common");
  const { push, locale, pathname } = useRouter();
  return (
    <div className="cs-widget my-3">
      <h3 className="cs-widget-title">{t("help_center")}</h3>
      <StyledAccordion className="cs-widget my-3">
        <div className="cs-widget mb-5">
          <div className="widget widget-categories mb-5">
            <ul>
              {content?.map((cont, idx) => {
                const isLastPath = lastPath === cont?.path?.path;

                return (
                  <li
                    className={`d-flex`}
                    // onClick={handleCloseFaqsOffCanvas}
                    key={idx}
                  >
                    <i className="fe-book text-muted mt-2 mr-2"></i>
                    <ActiveLink
                      activeClassName="active pointer2"
                      role="button"
                      fuzzy={
                        pathname.includes("faqs") && cont?.path?.path === "faqs"
                          ? true
                          : false
                      }
                      href={
                        cont?.path?.path == "#chat-with-support"
                          ? "#chat-with-support"
                          : "/help/" + cont?.path?.path
                      }
                    >
                      <a
                        className={`cs-widget-link ${
                          isLastPath ? "active" : ""
                        }`}
                        style={{ width: "fit-content" }}
                      >
                        {cont?.content.title[locale] || t(cont?.path.name)}
                      </a>
                    </ActiveLink>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </StyledAccordion>
    </div>
  );
};

export default FaqSidebarContent;
const StyledAccordion = styled.div`
  .collapse {
    max-height: 0;
    overflow: hidden;
    transition: all 0.5s cubic-bezier(0, 1, 0, 1);
    display: block;
    pointer-events: none;
    padding: 0 !important;
    margin: ${({ theme }) =>
      theme.rtl ? ".25rem  1.375rem 0 0" : ".25rem 0 0 1.375rem"};
  }
  .collapse.show {
    height: auto;
    max-height: 9999px;
    pointer-events: all;
    transition: all 0.5s cubic-bezier(1, 0, 1, 0);
    margin: ${({ theme }) =>
      theme.rtl ? ".25rem  1.375rem 0 0" : ".25rem 0 0 1.375rem"};
  }
`;

{
  /*
  
    const [clicked, setClicked] = useState(lastPath.includes("about"));
  const onAccordionHeadClick = () => {
    setClicked((prev) => !prev);
  };

  <li>
<a
  className={`cursor widget-link ${
    !clicked ? "collapsed" : ""
  }`}
  aria-expanded={`${clicked ? "true" : "false"}`}
  data-bs-toggle="collapse"
  onClick={() => {
    push(cont?.path?.path);
    onAccordionHeadClick();
  }}
>
  {cont?.content.title[locale] || t(cont?.path.name)}
</a>
<ul className={`collapse ${clicked ? "show" : ""}`}>
  {aboutContent?.map((item,id) => {
    return (
      <li
        key={id}
        className="d-flex"
        onClick={()=>push(item?.path?.path)}
      >
        <ActiveLink
          prefetch={false}
          activeClassName="active"
          href={item?.path?.path}
        >
          <a
            className={`widget-link widget-link-arrow-hidden text-capitalize ${
              item?.path?.path === lastPath ? "active" : ""
            }`}
          >
            {t(item?.content.title[locale])}
          </a>
        </ActiveLink>
      </li>
    );
  })}
</ul>
</li> */
}
